// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"713":"5b254844","914":"1d465d33"}[chunkId] + ".chunk.js";
};